// tslint:disable
export const fr = {
  VerifyStatus: 'Vérifier le statut',
  MarkAsDispensed: 'Marquer comme délivré',
  MarkAsSampled: 'Marquer comme échantillon',
  UndoDispense: 'Annuler délivrer',
  UndoSample: 'Annuler échantillon',
  MarkAsDestroyed: 'Marquer comme détruit',

  Alert: 'Alerte',
  ErrorCode: 'Code d\'erreur',
  WarningFromNmvs: 'Avertissement du système national de vérification des médicaments, pour l\'EPC',
  Reason: 'Raison',
  ContactAcknowledge: 'Veuillez contacter un membre de votre groupe pour confirmer la réception de ce message.',
  Acknowledge: 'Confirmer',

  CleanDateFormat: 'dd-mm-yyyy  h:MM:ss TT',
  ExpiryDateFormat: 'dd-mm-yyyy',
  ShortenedExpiryDateFormat: 'dd-mm-yyyy',

  ClearCompleted: 'Vider complétés',
  ManualEntry: 'Entrée Manuelle',

  FileName: 'Nom de fichier',
  Download: 'Télécharger',
  ImvoPilotSetupInstructions: 'IMVO Pilot Setup Instructions',
  ZebraDevicesSetupInstructions: 'Zebra Devices Setup Instructions',
  DataLogicGryphonGD4400: 'DataLogic Gryphon GD4400',
  DataLogicMagellan9800i: 'DataLogic Magellan 9800i',
  DataLogicMagellan3200VSI: 'DataLogic Magellan 3200 VSI',
  '232KeyConfiguration': '232Key configuration settings for DataLogic Magellan 3200 VSI',

  ProductDetails: 'Détails du produit',
  UserDetails: 'Détails de l\'utilisateur',
  ProductIdentification: 'Identifiant de produit',
  SerialNumber: 'Numéro de série',
  Expiry: 'Date de péremption',
  LotNumber: 'Numéro de lot',
  Status: 'Statut',

  DeviceInfo: 'Informations de l’appareil',
  UserProfile: 'Profile',
  Users: 'Utilisateurs',
  Settings: 'Paramètres',
  Documentation: 'Documentation',
  Logout: 'Déconnexion',

  LoginErrorConnectivity: 'Vous devez avoir accès à internet lors de la première connexion.',
  SessionTimeout: 'Session expirée.',
  InvalidUsernamePassword: 'Utilisateur ou mot de passe invalide.',
  Unauthorized: 'Non autorisé.',
  TenantDoesNotExist: 'Il n\'existe pas de client pour l\'identifiant: ',
  Username: 'Utilisateur',
  Password: 'Mot de passe',
  UsernameRequirement: 'Le nom d\'utilisateur doit contenir de 5 à 50 caractères',
  RetypePassword: 'Confirmer le mot de passe',
  Login: 'Connexion',
  FirstName: 'Prénom',
  LastName: 'Nom de famille',
  ForgotPassword: 'Mot de passe oublié',
  ConfirmPasswordReset: 'Confirmer la réinitialisation du mot de passe',
  ConfirmPasswordResetMessage: 'Voulez-vous vraiment réinitialiser le mot de passe de {{username}}?',
  ResetPassword: 'Réinitialiser le mot de passe',
  PasswordResetSuccess: 'Un courriel a été envoyé à l\'adresse donnée. Veuillez suivre les instructions qui s\'y trouvent pour compléter la réinitialisation de votre mot de passe.',
  PasswordResetError: 'Error: could not send the password reset email. Please try again in a few minutes.',
  PasswordResetOfflineError: 'Erreur: vous devez être en ligne pour réinitialiser votre mot de passe.',
  ForgotPasswordContactAdmin: 'Veuillez contacter votre administrateur Active Directory.',
  Email: 'Adresse courriel',
  OtherActions: 'Autres actions',
  UserInfoWarning: 'Avertissement: le nom d\'utilisateur, le prénom et le nom de famille ne peuvent plus être changés après création de l\'utilisateur.',

  ScannedDateTime: 'Date/Heure du balayage',
  NmvsResponseTime: 'Temps de réponse du NMVS',
  OptelResponseTime: 'Temps de réponse d\'Optel',
  TotalResponseTime: 'Temps de réponse total',
  Seconds: 'secondes',
  NotApplicable: 'S.O.',
  
  Scan: 'Scanner',
  ScanOrTypeEpc: 'Scanner ou saisir le Code de Produit Électronique',
  EnterEpcManually: 'Entrez le code de produit manuellement',
  EpcScannedAuditMessage: '{{username}} a scanné l\'EPC: {{epc}}, avec l\'opération: {{operation}}',
  AlertAcknowledgedAuditMessage: '{{username}} a accusé réception de l\'alerte pour l\'ID de transaction client: {{clientTransactionId}}',
  Pending: 'En cours',
  NotFound: 'Introuvable',
  ProductCodeRequired: 'Un code de produit est requis.',
  SerialNumberRequired: 'Un numéro de série est requis.',
  BatchIdentifierRequired: 'Un numéro de lot est requis.',
  ExpiryDateRequired: 'Une date de péremption est requise.',
  UnprocessableEntity: 'Impossible de traiter l\'entité',

  DeviceId: 'Identifiant de l\'appareil',
  SystemInfo: 'Informations système',
  Credentials: 'Informations',
  Preferences: 'Préférences',
  Country: 'Pays',
  Language: 'Langue',
  Certificate: 'Certificat',
  CertificatePassword: 'Mot de passe du certificat',
  LocationIdentifier: 'Identifiant d\'emplacement',
  Processing: 'En traitement...',
  Save: 'Sauvegarder',
  CreateUser: 'Créer un utilisateur',
  Submit: 'Soumettre',
  ClientId: 'Entrez l‘identifiant de client',
  FileNullError: 'Une erreur s\'est produite lors de la lecture du fichier.',
  InvalidFileError: 'Erreur: le fichier doit se terminer par .pfx ou .p12',
  OfflineSettingsMessage: 'Vous ne pouvez pas mettre à jour les paramètres en mode hors connexion.',

  RegisterDevice: 'Enregister l\'appareil',
  UnregisterDevice: 'Désenregistrer l\'appareil',
  UnregisterDeviceWarning: 'Si vous cliquez ce bouton, votre appareil sera désenregistré de votre emplacement jusqu\'à ce qu\'il soit enregistré à nouveau.',

  Details: 'Détails',
  User: 'Utilisateurs',
  Barcode: 'Code à barres',
  Pin: 'NIP',
  RetypePin: 'Confirmer NIP',
  Role: 'Rôle',
  ChangePIN: 'Changer de NIP',
  ChangePassword: 'Changer de mot de passe',
  PasswordMatchError: 'Le mot de passe ne correspond pas.',

  NoAvailableOperations: 'Aucune opération n\'est disponible pour cet item.',
  Verify: 'Vérifier',
  TryVerifyAgain: 'Essayer de Vérifier à nouveau',
  Dispense: 'Délivrer',
  Sample: 'Échantilloner',
  Destroy: 'Détruire',
  Reintroduce: 'Réintroduire',
  PleaseWait: 'Patientez svp...',
  ProductCode: 'Code de produit',
  AvailableOperations: 'Opérations disponibles',

  Cancel: 'Annuler',
  AddUser: 'Ajouter un utilisateur',
  EditUser: 'Modifier un utilisateur',

  RoleTypeOptelAdmin: 'Admin Optel',
  RoleTypeOptelSupport: 'Support Optel',
  RoleTypeTenantAdmin: 'Admin Tenancier',
  RoleTypeOperator: 'Opérateur',
  RoleTypeViewer: 'Visualisateur',
  RoleTypeUnknown: 'Inconnu',

  Back: 'Retour',
  ActivateUser: 'Activer l\'utilisateur',
  DeactivateUser: 'Désactiver l\'utilisateur',
  DeleteUser: 'Supprimer l\'utilisateur',
  Delete: 'Supprimer',
  DeleteUserWarning: 'Si vous cliquez ce bouton, l\'utilisateur sera supprimé permanament et son nom d\'utilisateur ne sera plus disponible.',
  DeleteUserConfirmation: 'Êtes-vous certain de vouloir supprimer {{username}} ?',
  Yes: 'Oui',
  No: 'Non',
  ConfirmDeletion: 'Confirmer la suppression',
  Error: 'Erreur',
  CommunicationError: 'Une erreur de communication s\'est produite avec le serveur.',
  SaveError: 'Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.',
  ClickTryAgain: 'Cliquez ici pour réessayer.',
  ClickErrorIconTryAgain: 'Cliquez sur l\'icône d\'erreur pour réessayer.',

  LandingPageSloganPart1: 'AAC - Pilote pour L’industrie canadienne de l’aluminium primaire.',
  LandingPageSloganPart2: '',
  FMDAcronym: 'FMD',
  EuropeanAcronym: 'EU',
  TermsAndConditions: 'Termes et Conditions',
  AboutOptel: 'À propos du Groupe OPTEL',
  AllRightsReserved: 'Tous droits réservés',
  OptelGroup: 'Groupe OPTEL',

  Online: 'En ligne',
  Offline: 'Hors ligne',
  AwaitingConnection: 'En attente de connexion...',
  SimulateOffline: 'Simuler le mode hors ligne',
  UndoOfflineWarning: 'Attention: L\'opération d\'annulation est désactivée en mode hors ligne.',
  
  NothingToShow: 'Rien à afficher.',
  LoadingCerta: 'Certa est en cours de chargement. Si l\'opération prend plus que 10 secondes, rafraîchissez la page.',

  OptelTermsOfUseTitle: 'Conditions d\'utilisation d\'Optel',
  NmvsTermsOfUseTitle: 'Conditions d\'utilisation du NMVS',
  NmvsTermsOfUseWarning: 'Remarque: pour être accepté par l\'admin de l\'emplacement',
  Accept: 'Accepter',
  Decline: 'Refuser',
  Ignore: 'Ignorer',
  Dismiss: 'Rejeter',
  ClickHere: 'cliquez ici',
  
  MustAcceptTermsToLogin: 'Vous devez accepter les termes d\'utilisation pour vous connecter.',
  MustBeOnlineToAcceptTermsToLogin: 'Vous devez devez avoir accès à internet afin d\'accepter les termes d\'utilisation pour vous connecter.',

  Austria: 'Autriche',
  Belgium: 'Belgique',
  Bulgaria: 'Bulgarie',
  Croatia: 'Croatie',
  Cyprus: 'Chypre',
  CzechRepublic: 'République Tchèque',
  Denmark: 'Danemark',
  Estonia: 'Estonie',
  Finland: 'Finlande',
  France: 'France',
  Germany: 'Allemagne',
  Greece: 'Grèce',
  Hungary: 'Hongrie',
  Iceland: 'Islande',
  Ireland: 'Irlande',
  Italy: 'Italie',
  Latvia: 'Lettonie',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituanie',
  Luxembourg: 'Luxembourg',
  Malta: 'Malte',
  Netherlands: 'Pays-Bas',
  Norway: 'Norvège',
  Poland: 'Pologne',
  Portugal: 'Portugal',
  Romania: 'Roumanie',
  Slovakia: 'Slovaquie',
  Slovenia: 'Slovénie',
  Spain: 'Espagne',
  Sweden: 'Suède',
  Switzerland: 'Suisse',
  UnitedKingdom: 'Royaume-Uni',

  UnableToParseEpc: 'Analyse du code de produit électronique impossible.',
  UnderSizeError: 'Erreur de taille insuffisante',
  OverSizeError: 'Erreur de taille excessive',
  FixedSizeError: 'Erreur de taille fixe',
  NoSerializationData: 'Aucune donnée de sérialisation.',
  InvalidCheckDigit: 'Chiffre de contrôle invalide.',
  NoProductCodeForGtin: 'Aucun code de produit n\'a été trouvé pour GTIN.',
  UrnFormatNotSupported: 'Format d\'Urn non pris en charge.',
  InvalidSymbologyIdentifier: 'Identificateur de symbologie invalide.',
  NoSymbologyIdentifier: 'Aucun identifiant de symbologie.',
  CouldNotFindTypeInfo: 'Impossible de trouver un TypeInfo.',
  NullTypeInfo: 'TypeInfo ne peut pas être nul.',
  DigitsOnly: 'L\'un des groupes IA ne pouvant contenir que des chiffres contient des caractères non valides.',
  CannotSerializeUnknownAi: 'Impossible de sérialiser l\'IA avec un type inconnu.',
  CheckValueNotChar: 'Le chiffre de contrôle doit être un chiffre.',
  CheckValueTooBig: 'Le chiffre de contrôle ne peut être plus grand que 9.',
  InvalidFormat: 'Format invalide.',
  CapsLockDetected: 'Le scan a été bloqué car la touche VERMAJ est active.',
  CapsLockSolution: 'Appuyez sur la touche VERMAJ de vôtre clavier puis scannez le code à nouveau.',
  ScanAttemptDetected: 'Un balayage a été détecté, mais il ne peut être analysé.',
  ScanAttemptSolution: 'Veuillez vous assurer que le scanneur est correctement configuré pour fonctionner avec l\'application Certa, tel que requis par Optel.',
  Active: 'Actif',
  FullName: 'Nom complet',
  OnlineAssistance: 'Assistance en ligne Certa',
  UnknownErrorOccurred: 'Une errur inconnue est survenue dans {{function}}.',
  SeparatorMissing: 'Séparateur de caractères GS manquant',
  SeparatorSolution: 'Reconfigurer le scanneur et convertir le caractère GS en espace ou en ^.',
  ScanCount: 'Nombre de balayages',
  ProductName: 'Nom du produit',
  ConfirmUnregisterDeviceMessage: 'Êtes-vous certain de vouloir désenregistrer votre appareil?',
  Confirm: 'Confirmer'
};



// WEBPACK FOOTER //
// ./src/translations/translations.fr.ts